import { AuthFormStep } from '@as-react/common-types';
import { all, put, takeLatest } from 'redux-saga/effects';
import { authActions } from '../../authentication/actions/AuthActions.creators';
import { AuthFormActionsTypes } from '../../../enums/ActionEnums';
function fromForgottenToLogin(action) {
    return action.payload.from === AuthFormStep.PASSWORD_FORGOTTEN && action.payload.to === AuthFormStep.LOGIN;
}
function fromLoginToForgotten(action) {
    return action.payload.from === AuthFormStep.LOGIN && action.payload.to === AuthFormStep.PASSWORD_FORGOTTEN;
}
export function* stepUpdate(action) {
    try {
        if (fromForgottenToLogin(action) || fromLoginToForgotten(action)) {
            yield put(authActions.resetError());
        }
    }
    catch (_a) { }
}
export function* stepUpdateSaga() {
    yield takeLatest(AuthFormActionsTypes.UPDATE_STEP_TYPE, stepUpdate);
}
export default function* authFormSaga() {
    yield all([stepUpdateSaga()]);
}
